import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: ${props => (props.theme.isMobile ? '0' : '0px 0px 10px 0px')};

  > div {
    text-transform: uppercase;
    font-family: ${props => props.theme.fontFamilyBody};
    font-weight: ${props => props.theme.fontWeightHeavy};
    font-size: 20px;
    line-height: 22px;
  }
`;

const Title = styled.div`
  color: ${props => props.theme.bodyColor};
`;

const Query = styled.div`
  color: ${props => props.theme.primaryColor};
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;

export default function SidebarComponentHeader({ title, query }) {
  return (
    <Container>
      <Title>{title}</Title>
      {!!query && <Query>{query}</Query>}
    </Container>
  );
}

SidebarComponentHeader.propTypes = {
  title: PropTypes.string.isRequired,
  query: PropTypes.string,
};

SidebarComponentHeader.defaultProps = {
  query: null,
};
